import React, { useEffect } from 'react';
import { Chart } from '@antv/g2';

const RejectedTransactionsType = ({ transactionsData }) => {
  const loadTransactionsTypeChart = () => {
    const chart = new Chart({
      container: 'rejected-transactions-type-chart',
      height: 150,
      autoFit: true
    });

    chart
      .interval()
      .data([
        { month: 'Marzo', name: 'Nacionales', value: transactionsData?.detail?.national?.rejected, color: '#6950E8' },
        { month: 'Marzo', name: 'Internacionales', value: transactionsData?.detail?.international?.rejected, color: '#F4A261' },
      ])
      .encode('x', 'month')
      .encode('y', 'value')
      .encode('color', 'color')
      .encode('series', 'name')
      .scale('color', { type: 'identity' })
      .scale('x', { paddingOuter: -10 })
      .legend(false)
      .axis(false)
      .encode('size', 40)
      .style('radiusTopLeft', 20)
      .style('radiusTopRight', 20)
      .tooltip((data) => ({
        name: data.name,
        value: data.value,
      }));

    chart.render();
  };

  useEffect(() => {
    loadTransactionsTypeChart();
  }, [transactionsData]);

  return (
    <div id="rejected-transactions-type-chart"></div>
  )
}

export default RejectedTransactionsType;